export function pinnedGuestIdentity(search: string): string | null {
    const params = new URLSearchParams(search);
    if (params.has('user')) {
        const id = params.get('user')!;
        if (!/^[0-9]+$/.test(id) || id.length > 39 || BigInt(id) > (1n << 128n) - 1n) {
            throw new Error('The game link contains an invalid guest identity.');
        }
        return id;
    }
    return params.get('guest_id') || null;
}

export function pinGuestIdentity(search: string, storage: Pick<Storage, 'setItem' | 'removeItem'>): void {
    const id = pinnedGuestIdentity(search);
    if (id !== null) {
        storage.setItem('guest_id', id);
        // A cached session can belong to Discord even if the saved guest ID matches.
        storage.removeItem('session_token');
    }
}

export function randomGuestIdentity(): string {
    const random = crypto.getRandomValues(new BigUint64Array(2));
    return ((random[0] << 64n) | random[1]).toString();
}
